import { Router } from '@angular/router';
import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Accelerator } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService, router: Router): GridSetup<Accelerator> {

	return {
		rowName: { singular: 'Accelerator', plural: 'Accelerators' },
		getRowKey: row => '' + row.accId,
		stateKey: 'delivery-accelerators-grid',
		renderRowClasses: row => row.canceled ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [],
		actions: getActions(router),
		buttons: [],
		columns: getColumns(util, app),
	}
}
